import {createContext} from 'react'

export const AppAdminContext = createContext({
    showSpModePage: false,
    updateShowSpModePage: (_showSpModePage: boolean) => {
    },
})
